import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  CircularProgress,
  InputAdornment,
  TablePagination,
  TextField,
  Typography,
} from '@mui/material';
import React, { FC } from 'react';
import { FreeCreditsHistoryDialogViewModel } from '../../../types';
import { FreeCreditsHistoryTable } from './FreeCreditsHistoryTable';
import { BhiDialog } from 'src/UIKit';

const FreeCreditsHistoryDialogView: FC<FreeCreditsHistoryDialogViewModel> = ({
  open,
  timezone,
  loading,
  failed,
  entries,
  count,
  searchQuery,
  sort,
  page,
  pageSize,
  onSearchChange,
  onSortChange,
  onPageChange,
  onRetry,
  close,
}) => (
  <BhiDialog isOpen={open} onClose={close} title="Free Credits History" maxWidth="md" fullWidth>
    <Box sx={{ padding: '0 20px 12px', position: 'relative', minHeight: 120 }}>
      <TextField
        size="small"
        fullWidth
        placeholder="Search by date, type, amount or reason"
        value={searchQuery}
        onChange={e => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        sx={{ marginBottom: 1 }}
      />
      {loading && (
        <CircularProgress
          size={24}
          sx={{ position: 'absolute', top: '50%', left: '50%', marginLeft: -1.5 }}
        />
      )}
      <Box sx={{ opacity: loading ? 0.5 : 1 }}>
        <FreeCreditsHistoryTable
          entries={entries}
          timezone={timezone}
          sorting={{ value: sort, onChange: onSortChange }}
        />
        {!loading && entries.length === 0 && (failed || searchQuery.trim() !== '') && (
          <Box sx={{ paddingTop: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {failed ? 'Failed to load the history' : 'Nothing matches the search'}
            </Typography>
            {failed && (
              <Button size="small" onClick={onRetry} sx={{ marginTop: 1 }}>
                Try again
              </Button>
            )}
          </Box>
        )}
        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={pageSize}
          rowsPerPageOptions={[pageSize]}
          onPageChange={(_, value) => onPageChange(value)}
        />
      </Box>
    </Box>
  </BhiDialog>
);

export default FreeCreditsHistoryDialogView;
